import React from 'react';
import { useI18n } from '../../utils/i18n';
import { AlertTriangle, RotateCw } from 'lucide-react';

// #256: Gemeinsamer Zustandsblock fuer Listenbereiche (Dashboard-Spalten).
//
// Warum: Die Spalten kannten bisher nur "leer". Schlug der erste Abruf fehl —
// beim Kaltstart der haeufigste Fall —, stand dort "Keine offenen Tickets",
// also eine falsche Aussage, und es gab keinen Weg zurueck ausser die ganze
// Seite neu zu laden. Auch "wird gerade geladen" war nicht von "es gibt
// nichts" zu unterscheiden.
//
// Drei Zustaende, eine Geometrie (die bestehende .dashboard-empty-state):
//   loading  Ladekreis, nur bis zum ERSTEN Ergebnis
//   error    Hinweis + "Erneut versuchen"
//   empty    wie bisher
//
// Der Fehlerblock ersetzt bewusst NUR eine ohnehin leere Liste. Sind Daten da
// und klemmt bloss die Aktualisierung, sind die alten Daten mehr wert als ein
// Fehlerkasten — dafuer gibt es den Hinweis im Spaltenkopf.
const ListState = ({ variant = 'empty', icon = null, message, hint = null, onRetry = null }) => {
  const { t } = useI18n();

  if (variant === 'loading') {
    // role="status": Vorlesewerkzeuge melden den Wechsel, ohne die Eingabe zu
    // unterbrechen — wie bei den Toasts (Frontend Phase 2).
    return (
      <div className="dashboard-empty-state" role="status">
        <div className="loading-spinner"></div>
        <p>{message || t('common.loading', 'Wird geladen…')}</p>
      </div>
    );
  }

  if (variant === 'error') {
    return (
      <div className="dashboard-empty-state" role="status">
        <AlertTriangle size={32} style={{ opacity: 0.5 }} aria-hidden="true" />
        <p>{message || t('common.loadFailed', 'Konnte nicht geladen werden')}</p>
        {onRetry && (
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={onRetry}
            style={{ marginTop: '12px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
          >
            <RotateCw size={14} aria-hidden="true" />
            {t('common.retry', 'Erneut versuchen')}
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="dashboard-empty-state">
      {icon}
      <p>{message}</p>
      {hint && (
        <p style={{ fontSize: '0.8rem', marginTop: '8px' }} className="list-state-hint">
          {hint}
        </p>
      )}
    </div>
  );
};

export default ListState;
